import {Link} from 'react-router'
import './style.css'
import BillingReminder from 'components/BillingReminder'

class SubNav extends React.Component {
  render () {
    let path = this.props.location.pathname
    let {user, subscriptionExpired} = this.props
    return (
      <div className='mk-sub-navbar'>
        <div className='container'>
          <ul className='mk-subnav'>
            <li className={'sub-nav-li ' + (path.startsWith('/reports') &&
              (path !== '/reports/transactions') &&
              (path !== '/reports/invoices') &&
              (path !== '/reports/shifts')
              ? 'active' : '')}>
              <Link to='/reports/summary' className={path.startsWith('/reports') ? '' : 'hideSales'}>Sales</Link>
            </li>
            { this.props.links.map((link, index) => {
              return (
                <li key={index} className={'sub-nav-li ' + (path.startsWith(link.href) ? 'active' : '')}>
                  {this._isUrl(link.href) ? <a href={link.href}>{link.label}</a> : <Link to={link.href}>{link.label} { link.isNew && <span className='new-label'>NEW</span> }</Link>}
                </li>
              )
            })}
            <div className='visible-lg visible-md'>
              <BillingReminder user={user} subscriptionExpired={subscriptionExpired} />
            </div>
          </ul>
        </div>
      </div>
    )
  }
  _isUrl = (url) => {
    return url.indexOf('http') >= 0
  }
}

export default SubNav



// WEBPACK FOOTER //
// ./app/components/SubNav/SubNav.js